import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { FormFieldBaseComponent, ViewProviders } from '@elderbyte/ngx-starter'
import { ConstraintInput } from '../constraintInput'
import { PropertyInputComponent } from '../../../../../properties/property-input/property-input.component'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-constraint-input',
  templateUrl: './constraint-input.component.html',
  styleUrls: ['./constraint-input.component.scss'],
  viewProviders: [ViewProviders.ParentControlContainer],
  imports: [PropertyInputComponent, AsyncPipe],
})
export class ConstraintInputComponent extends FormFieldBaseComponent<ConstraintInput> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  @Input()
  public showLabel: boolean

  @Input()
  public allowedValues: string[]

  @Input()
  public tripleStateBoolean: boolean

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    super()
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onConstraintValueUpdate($event: string[]): void {
    this.updateValue(new ConstraintInput(this.value.spec, $event))
  }
}
